import React, { Component } from "react";
import HomeHeader from "../../components/HomePage/Header/Header";
import PreFooter from "../../components/shared/PreFooter/PreFooter";
import Footer from "../../components/shared/Footer/Footer";
import Pricing from "../../components/HomePage/Pricing/Pricing";
import postscribe from "postscribe";
import boton from "../../assets/img/boton.png";

class PricingHome extends Component {
  componentDidMount() {
    const script = document.createElement("script");
    
    script.onload = () => {
      this.handler = window.ePayco.checkout.configure({
        key: "ae022d333e2690638eaea6447d8796ba",
        test: false,
      });

      const plans = {
        T: {
          name: "Dólar SET-FX | Trimestral",
          description: "...",
          currency: "cop",
          country: "co",
          amount: "624047",
          tax: "99638",
          tax_base: "524409",
          external: "false",
        },
        S: {
          name: "Dólar SET-FX | Semestral",
          description: "...",
          currency: "cop",
          country: "co",
          amount: "1157427",
          tax: "184799",
          tax_base: "972628",
          external: "false",
        },
        A: {
          name: "Dólar SET-FX | Anualidad",
          description: "...",
          currency: "cop",
          country: "co",
          amount: "2124483",
          tax: "339203",
          tax_base: "1785280",
          external: "false",
        },
      };

      document.querySelectorAll(".btn-pay").forEach((btn) => {
        btn.addEventListener("click", () =>
          this.handler.open(plans[btn.dataset.plan])
        );
      });
    };
    document.head.appendChild(script);
  }
  render() {
    return (
      <div id="container" className="home_page">
        <HomeHeader empty={true} />
        <div className="boxed">
          <div className="container-fluid">
            <div className="row">
              <Pricing />
            </div>
            <PreFooter></PreFooter>
            <Footer></Footer>
          </div>
        </div>
      </div>
    );
  }
}

export default PricingHome;
